import React, { Component, Fragment } from "react";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import CallAction from "../elements/callaction/CallAction";
import WhatsAppButton from "../component/WhatsAppButton";
import Gallery from "../component/Gallery";
import TeamTwo from "../blocks/team/TeamTwo";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import { videoTagString, VideoTag } from "react-video-tag";
import Helmet from "../component/common/Helmet";

import { withTranslation } from 'react-i18next';

import video from "../assets/images/service/video_1.mp4";
import bgImage from "../assets/images/bg/bg-image-24.jpg";

import portfolioImg1 from "../assets/images/portfolio/portfolio-1.png";
import portfolioImg2 from "../assets/images/portfolio/portfolio-2.png";
import portfolioImg3 from "../assets/images/portfolio/portfolio-3.png";
import portfolioImg4 from "../assets/images/portfolio/portfolio-4.png";

videoTagString({
  src: video,
  poster: bgImage,
});

class StudioAgency extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }

  openModal = () => {
    this.setState({ isOpen: true });
  };

  render() {
    const { t } = this.props;

    const SlideList = [
      {
        textPosition: "text-left",
        category: "",
        title: t("Encabezado video"),
        description: t("Descripcion"),
        buttonText: t("Contact Us"),
        buttonLink: "/contact",
      },
    ];

    const PortfolioList = [
      {
        images: portfolioImg1,
        category: "",
        title: t("Exterior"),
        link: "/product-outside"
      },
      {
        images: portfolioImg2,
        category: "",
        title: t("Interior"),
        link: "/product-inside"
      },
      {
        images: portfolioImg3,
        category: "",
        title: t("Fachadas"),
        link: "/product-facades"
      },
      {
        images: portfolioImg4,
        category: "",
        title: t("Piscinas"),
        link: "/product-pools"
      },
    ];

    return (
      <Fragment>
        <Helmet pageTitle="Black Stone" />

        {/* Start Header Area  */}
        <Header />
        {/* End Header Area  */}

        {/* Start Slider Area   */}
        <div className="slider-wrapper">
          {/* Start Single Slide */}
          {SlideList.map((value, index) => (
            <div
              className="slide slide-style-2 slider-video-bg d-flex align-items-center justify-content-center"
              key={index}
              data-black-overlay="6"
            >
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-8">
                    <div className={`inner ${value.textPosition}`}>
                      {value.category ? <span>{value.category}</span> : ""}
                      {value.title ? (
                        <h1 className="title">{value.title}</h1>
                      ) : (
                        ""
                      )}
                      {value.description ? (
                        <p className="description">{value.description}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="video-background">
                <VideoTag
                  autoPlay={`${true}`}
                  muted={`${true}`}
                  playsInline={`${true}`}
                  loop={`${true}`}
                  src={video}
                  poster={bgImage}
                />
              </div>
            </div>
          ))}
          {/* End Single Slide */}
        </div>
        {/* End Slider Area   */}

        {/* Start Portfolio Area  */}
        <div className="creative-portfolio-wrapper bg_color--1">
          <div className="creative-portfolio-wrapper plr--10">
            <div className="row row--5">
              {PortfolioList.map((value, i) => (
                <div className="col-lg-3 col-md-6 col-12" key={i}>
                  <div className="portfolio-style--3">
                    <div className="thumbnail">
                      <a href="/portfolio-details">
                        <img
                          className="w-100"
                          src={value.images}
                          alt="Portfolio Images"
                        />
                      </a>
                    </div>
                    <div className="content">
                      <p className="portfoliotype">{value.category}</p>
                      <h4 className="title">
                        <a href="/portfolio-details">{value.title}</a>
                      </h4>
                      <div className="portfolio-btn">
                        <a className="rn-btn text-white" href={value.link}>
                          {t("verProducto")}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* End Portfolio Area  */}

        {/* Start Whatsapp Button */}
        <div>
          <Gallery />
        </div>
        {/* End Whatsapp Button */}

        {/* Start Team Area */}
        <div className="rn-team-area ptb--80 bg_color--5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title service-style--3 text-center mb--60 mb_sm--0">
                  <h2 className="title3">{t("Procesos")}</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="text-center">
                <TeamTwo column="col-lg-2" teamStyle="" item={6} position="end" />
              </div>
            </div>
          </div>
        </div>
        {/* End Team Area */}

        {/* Start call To Action  */}
        <CallAction />
        {/* End call To Action  */}

        {/* Start Footer Area  */}
        <FooterTwo />
        {/* End Footer Area  */}

        {/* Start Whatsapp Button */}
        <div>
          <WhatsAppButton />
        </div>
        {/* End Whatsapp Button */}

        {/* Start Back To Top */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* End Back To Top */}
      </Fragment>
    );
  }
}

export default withTranslation()(StudioAgency);
